import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { GeneralService } from '../services/general.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-add-module',
  templateUrl: './add-module.component.html',
  styleUrls: ['./add-module.component.scss']
})
export class AddModuleComponent implements OnInit {
  auditForm: FormGroup;
  displayedColumns: string[] = [
    "Name",
    "action",
  ];
  constructor(private fb: FormBuilder,private GeneralService:GeneralService) { }

 
  ngOnInit() {
    this.getAllModules();
  }

  Module: any;
  AllModules:any[]=[];
  AllModulesfilter:any[]=[]
  // Add Category
  addModule() {
  if(this.Module){
    console.log(this.Module);
    this.Module = JSON.parse(this.Module);
    console.log(this.Module)
    this.GeneralService.addmodule(this.Module).subscribe((data)=>{
     this.getAllModules();
Swal.fire({
        icon: "success",
        title: "Success Add Module",
        showConfirmButton: false,
        timer:1000
      });
      this.Module=null;
    })
  
  }
  }

  getAllModules(){
    this.AllModules=[];
  
    this.GeneralService.getModule().then(clusters=>{
      this.AllModules=clusters;
      this.AllModulesfilter=clusters
      console.log(this.AllModules)
    })
  }

  DeleteModule(module:any){
this.GeneralService.DeleteModule(module.id).then(res=>{
  this.getAllModules();
  Swal.fire({
    icon: "success",
    title: "Success Deleted Module",
    showConfirmButton: false,
    timer:1000
  });

})
  }
}

